// packages/shared-utils/src/main/supportedDevices.ts
export { SDK_KEYBOARD_MOUSE_TYPE } from "./supportedDevicesConstants";

/** 子应用请用 ensureSupportedDevices / getSupportedDevicesSync */
export {
  ensureSupportedDevices,
  getSupportedDevicesSync,
} from "./supportedDevicesStore";
export type {
  SupportedDevicesMap,
  SupportedDeviceType,
} from "./supportedDevices.types";

import type { SupportedDevicesMap } from "./supportedDevices.types";
import { getSupportedDevicesSync } from "./supportedDevicesStore";

/** 兼容历史 `import { SUPPORTED_DEVICES }`；须在 ensureSupportedDevices 之后访问 */
export const SUPPORTED_DEVICES = new Proxy({} as SupportedDevicesMap, {
  get(_target, prop) {
    return (getSupportedDevicesSync() as Record<string | symbol, unknown>)[
      prop
    ];
  },
  ownKeys() {
    return Reflect.ownKeys(getSupportedDevicesSync());
  },
  getOwnPropertyDescriptor(_target, prop) {
    const sync = getSupportedDevicesSync() as Record<string | symbol, unknown>;
    if (prop in sync) {
      return {
        configurable: true,
        enumerable: true,
        value: sync[prop as string],
        writable: true,
      };
    }
    return undefined;
  },
});
